define('components/handlers/kyc-report/start-kyc-report-order',[
    'jquery',
], function ($) {
    $.extend(companyInfo.handlers, {
        'start-kyc-report-order': function () {
            var complianceMenu = $("#compliance-menu-items");
            var spinner = $("#compliance-menu-spinner");
            var organizationID = $('input[name="organization-id"]').first().val();

            // replace button with spinner
            complianceMenu.addClass("hidden");
            spinner.removeClass("hidden");

            fetch('/kyc/reports/' + organizationID + '/create', {
                method: 'GET',
                headers: {'Content-Type': 'application/json'}
            }).then(function (response) {
                if (!response.ok) {
                    window.location = "/error";
                    return;
                }
                window.location = response.url;
            });
        },
    });
});

